/// <amd-module name="Reporting/BoardsCommon/BoardsReportingHeaderBreadcrumbService" />
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { Services, VssService } from "VSS/Platform/Context";
import { getBoardsAnalyticsRootUrl } from "./BoardsRoutingHelper";

import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";

export class BoardsReportingHeaderBreadcrumbService extends VssService implements IBreadcrumbItemService {
    private items = new ObservableArray<IBreadcrumbItem>();

    public getBreadcrumbItems(breadcrumbId: string): IReadonlyObservableArray<IBreadcrumbItem> {
        this.items.push({
            key: "analytics",
            text: "Analytics",
            href: getBoardsAnalyticsRootUrl(this.pageContext)
        });

        return this.items;
    }
}

Services.add("boards-reporting-header-breadcrumb-service", { serviceFactory: BoardsReportingHeaderBreadcrumbService });
